import React, { Component } from 'react';
import Modal from 'react-modal';

import { firebaseDB } from '../firebase';


class Blog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            publications: [],
            articleVisible: false,
            articleIdx: 0
        };

        this.publicationsRef = firebaseDB.ref('/blog/publications');
    }

    componentDidMount() {
        this.publicationsRef.on('child_added', (snapshot) => {
            this.setState((prevState, props) => ({
                publications: [
                    {
                        key: snapshot.key,
                        title: snapshot.val().title,
                        createdAt: snapshot.val().createdAt,
                        content: snapshot.val().content
                    },
                    ...prevState.publications
                ]
            }));
        });
    }

    componentWillUnmount() {
        this.publicationsRef.off();
    }

    renderArticles() {
        return this.state.publications.map((article, index) => (
            <div key={index} className="portfolio-item ">
                <div className="portfolio-title">
                    <h4><a onClick={() => this.setState({ articleVisible: true, articleIdx: index })}>{article.title}</a></h4>
                    <div className="date">Bianka Dekoracje, {new Date(article.createdAt).toLocaleDateString()}</div>
                    <p dangerouslySetInnerHTML={{ __html: article.content.substring(0, 160).concat(' ...') }} />
                    <div className="m-top-20 m-bot-20">
                        <button className="btn btn-extra-small btn-dark-border btn-transparent " onClick={() => this.setState({ articleVisible: true, articleIdx: index })}> Czytaj więcej</button>
                    </div>
                </div>
            </div>
        ));
    }

    render() {
        const modalStyle = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.75)'
            },
            content: {
                position: 'absolute',
                top: '100px',
                left: '80px',
                right: '80px',
                bottom: '60px',
                border: '1px solid #ccc',
                background: '#fff',
                overflow: 'auto',
                WebkitOverflowScrolling: 'touch',
                borderRadius: '0px',
                outline: 'none',
                padding: '20px'

            }
        };

        let { publications, articleIdx } = this.state;

        return (
            <div className="portfolio portfolio-with-title portfolio-masonry blog-m col-4 gutter ">
                {this.renderArticles()}
                <Modal
                    style={modalStyle}
                    isOpen={this.state.articleVisible}
                    onRequestClose={() => this.setState({ articleVisible: false })}
                    contentLabel="Modal"
                >
                    <div className="col-md-8">
                        <div className="blog-classic">
                            <div className="blog-post">
                                <h4 className="text-uppercase">{ publications[articleIdx] ? publications[articleIdx].title : '' }</h4>
                                <ul className="post-meta">
                                    <li><i className="fa fa-user"></i>Bianka Dekoracje, {new Date(publications[articleIdx] ? publications[articleIdx].createdAt : null).toLocaleDateString()}
                                    </li>
                                </ul>
                                <p dangerouslySetInnerHTML={{ __html: publications[articleIdx] ? publications[articleIdx].content : '' }} />
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default Blog;


// WEBPACK FOOTER //
// ./src/blog/Blog.js